<template>
  <div>
    <div class="pageTitleWrap">
      <!-- <vs-breadcrumb :items="breadcrumb" class="marLeft12"></vs-breadcrumb> -->
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/modules/wms/manage/transfer' }"
          >库存调拨</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ pageTitle }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="common-wrap white">
      <div class="firstTitle">基本信息配置</div>
      <el-row v-if="transferNo">
        <el-col :span="2" class="colTitle">调拨单号</el-col>
        <el-col :span="12">{{ transferNo }}</el-col>
      </el-row>

      <el-form
        :rules="rules"
        ref="form"
        :disabled="!showGoodsDetail"
        :model="formData"
        label-width="80px"
      >
        <el-row :gutter="10">
          <el-col :span="16">
            <el-form-item label="调出仓库" prop="fromBodyId">
              <el-col :span="8">
                <el-select
                  v-model="formData.fromBodyId"
                  placeholder="请选择主体"
                  @change="getFromMainOptions"
                >
                  <el-option
                    v-for="item in storeMainList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-select
                  v-model="fromStoreId"
                  placeholder="请选择分仓"
                  @change="getFromLocOptions"
                >
                  <el-option
                    v-for="item in formStoreList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-select
                  v-model="fromLocId"
                  placeholder="请选择仓位"
                >
                  <el-option
                    v-for="item in fromLocOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="16">
            <el-form-item label="调入仓库" prop="toBodyId">
              <el-col :span="8">
                <el-select
                  v-model="formData.toBodyId"
                  placeholder="请选择主体"
                  @change="getToMainOptions"
                >
                  <el-option
                    v-for="item in storeMainList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-select
                  v-model="toStoreId"
                  placeholder="请选择分仓"
                  @change="getToLocOptions"
                >
                  <el-option
                    v-for="item in toStoreList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-select
                  v-model="toLocId"
                  placeholder="请选择仓位"
                >
                  <el-option
                    v-for="item in toLocOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="收货人" prop="receiver">
              <el-input
                v-model="formData.receiver"
                :disabled="!showGoodsDetail"
                placeholder="请填写收货人"
                v-if="showGoodsDetail"
              />
              <span v-else>{{ formData.receiver }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式" prop="mobile">
              <el-input
                v-model="formData.mobile"
                maxlength="11"
                placeholder="请填写联系方式"
                :disabled="!showGoodsDetail"
                v-if="showGoodsDetail"
              />
              <span v-else>{{ formData.mobile }}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="物流单号" prop="transitNo">
              <el-input
                v-model="formData.transitNo"
                :disabled="!showGoodsDetail"
                placeholder="请填写物流单号"
                class=""
                v-if="showGoodsDetail"
              />
              <span v-else>{{ formData.transitNo }}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="三方确认" prop="thirdFlag">
              <el-radio-group v-model="formData.thirdFlag">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="transferResson">
              <el-input type="textarea" v-model="formData.transferResson"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="收货地址" prop="receiveAddress">
              <el-col :span="8">
                <el-cascader
                  style="width: 100%"
                  size="large"
                  :options="options"
                  v-model="selectedOptions"
                  @change="handleChange"
                  :disabled="!showGoodsDetail"
                >
                </el-cascader>
                 <!-- <span v-else>{{ selectedOptions }}</span> -->
              </el-col>
              <el-col :span="12">
                <el-input
                  v-model="formData.receiveAddress"
                  class="w-full"
                  placeholder="请输入详细地址"
                  :disabled="!showGoodsDetail"
                  v-if="showGoodsDetail"
                  type="digit"
                />
                <span v-else>{{ formData.receiveAddress }}</span>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="common-wrap">
        <div class="firstTitle">调拨商品配置</div>
        <div class="flex" v-if="showGoodsDetail">
          <div class="flex">
            <vs-button
              type="border"
              size="small"
              @click.prevent="addNewGoods"
              class="common-btn"
              >批量添加</vs-button
            >
            <vs-button
              type="border"
              size="small"
              @click.prevent="deleteBatchGoods"
              class="common-btn mar-left-8"
              >批量删除</vs-button
            >
          </div>
        </div>

        <el-table
          :data="goodsList"
          border
          show-summary
          style="width: 100%; border-radius: 4px; margin-top: 20px"
          :summary-method="getSummaries"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="id" label="序号" width="60px" align="center">
            <template slot-scope="scope">
              {{ scope.$index+1 }}
            </template>
          </el-table-column>
          <el-table-column prop="skuCode" label="商品编码" width="120">
          </el-table-column>
          <el-table-column prop="barCode" label="69码" width="160">
          </el-table-column>
          <el-table-column prop="skuName" width="300px" label="商品名称">
          </el-table-column>
          <el-table-column prop="spec" label="规格"> </el-table-column>
          <el-table-column prop="availableAmount" label="库存" align="center">
          </el-table-column>
           <el-table-column prop="actualInQty" label="实际调拨入库" align="center" width="120">
          </el-table-column>
          <el-table-column prop="actualOutQty" label="实际调拨出库" align="center" width="120">
          </el-table-column>
          <el-table-column
            prop="num"
            label="调拨数量"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <div v-if="showGoodsDetail">
                <el-input-number
                  size="small"
                  :min="1"
                  @change="
                    amountChange(scope.row.num, scope.row.availableAmount)
                  "
                  :max="scope.row.availableAmount > 0 ? scope.row.availableAmount : 0"
                  v-model="scope.row.num"
                />
              </div>
              <div v-else>
                {{ scope.row.num }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" width="220">
            <template slot-scope="scope">
              <div v-if="showGoodsDetail">
                <el-input
                  v-model="scope.row.remark"
                  type="text"
                  placeholder="备注"
                />
              </div>
              <div v-else>
                {{ scope.row.remark }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            width="60px"
            label="操作"
            v-if="showGoodsDetail"
          >
            <template slot-scope="scope">
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 stroke-current"
                class="ml-2 text-primary"
                @click="deleteGoods(scope.$index)"
              />
            </template>
          </el-table-column>
        </el-table>

        <div
          class="flex alignCenter marTop18 search-add-wrap"
          v-if="showGoodsDetail"
        >
          <div class="input-tip">快捷录入</div>
          <search-input
            ref="bookmarkAutoSuggest"
            :autoFocus="true"
            :data="goodsOptions"
            :searchLimit="5"
            placeholder="请输入要添加的商品名或编号"
            inputClassses="w-full"
            show-action
            show-pinned
            hideGroupTitle
            background-overlay
            showName="skuName"
            @input="searchInputSuggest"
            @selected="selectOneGood"
          />
          <vs-button
            color="primary"
            type="flat"
            class="table-inner-btn"
            @click="addSuggestGood"
            >添加</vs-button
          >
        </div>
      </div>
    </div>
    <div class="fix-bottom">
      <vs-button
        v-if="showGoodsDetail"
        type="filled"
        @click.prevent="doSaveBill"
        class="marLeft12"
        >保存</vs-button
      >
      <vs-button type="border" @click.prevent="goParentPage" class="marLeft12">
        {{ showGoodsDetail ? "取消" : "返回" }}
      </vs-button>
    </div>
    <!-- 新增商品弹窗 -->
    <vs-prompt
   
      @cancel="goodsSuggest = ''"
      @accept="addBillGoods()"
      title="选择需要添加的商品"
      acceptText="确认"
      cancelText="取消"
      :active.sync="showAddGoodDialog"
    >
      <div class="con-exemple-prompt">
        <div class="flex flexStart">
          <!-- <v-select v-model="formData.fromStoreId" :reduce="opt => opt.id" :disabled="!showGoodsDetail"
                      :options="storehouseList" placeholder="请选择分仓" class="small-select"
                      @change="getFromLocOptions" @input="getFromLocOptions" v-validate="'required'"/> -->
          <v-select
            v-model="categoryId"
            :options="categoryOptions"
            :reduce="(opt) => opt.id"
            placeholder="请选择分类"
          >
            <div slot="no-options">暂无选项</div>
          </v-select>
          <gc-cmp-vs-input
            v-model="goodsSuggest"
            maxlength="200"
            class="marLeft20"
            placeholder="请输入商品编码/名称"
          />
          <vs-button
            type="border"
            @click.prevent="getAllGoods"
            class="marLeft20"
            >查询</vs-button
          >
        </div>
        <gc-cmp-vs-table
          ref="table"
          multiple
          v-model="selectedGoods"
          @selected="handleGoodsSelected"
          :data="goodsAllList"
          class="marTop18"
        >
          <template slot="thead">
            <vs-th>商品编码</vs-th>
            <vs-th>69码</vs-th>
            <vs-th>商品名称</vs-th>
            <vs-th>可用库存/库存</vs-th>
            <vs-th>规格</vs-th>
            <vs-th>分类</vs-th>
          </template>
          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="tr.skuCode" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].skuCode">
                  {{ data[indextr].skuCode }}
                </vs-td>
                <vs-td :data="data[indextr].barCode">
                  {{ data[indextr].barCode }}
                </vs-td>
                <vs-td :data="data[indextr].skuName">
                  {{ data[indextr].skuName }}
                </vs-td>
                 <vs-td :data="data[indextr].skuName">
                  {{ data[indextr].availableAmount }}/{{data[indextr].actualAmount}}
                </vs-td>
                <vs-td :data="data[indextr].spec">
                  {{ data[indextr].skuSpec }}
                </vs-td>
                <vs-td :data="data[indextr].categoryName">
                  {{ data[indextr].categoryName }}
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </gc-cmp-vs-table>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import selectPara from "@/components/selectPara";

import SearchInput from "@/modules/wms-manage/components/searchInput.vue";
import { Mod_Role_Warehouse } from "@/modules/server-api/RoleWarehouse";
import { CommodityCategoryApi } from "@/modules/server-api/commodity-sys/category-manage";
import { CommodityGoodsyApi } from "@/modules/server-api/commodity-sys/goods-manage";
import { TransferApi } from "@/modules/server-api/wms-manage/transfer";
import vSelect from "vue-select";
import GcCmpVsTable from "@/group-cloud/components/vsTable";
import GcCmpVsInput from "@/group-cloud/components/vsInput";
import { getThreeCategory } from "@/modules/commodity-sys/common.js";
import {
  WmsWarehouseApi,
  Mod_Warehouse_Types_Options, //库存类型
} from "@/modules/server-api/wms-manage/warehouse";
import { regionData, CodeToText, TextToCode } from "element-china-area-data";

export default {
  components: {
    vSelect,
    GcCmpVsTable,
    GcCmpVsInput,
    SearchInput,
    selectPara,
  },
  data() {
    let validate_fromBodyId = (rule, value, callback) => {
      if (
        !this.formData.fromBodyId ||
        !this.fromStoreId ||
        !this.fromLocId
      ) {
        callback(new Error());
      } else {
        callback();
      }
    };

    let validate_toBodyId = (rule, value, callback) => {
      if (
        !this.formData.toBodyId ||
        !this.toStoreId ||
        !this.toLocId
      ) {
        callback(new Error());
      } else {
        callback();
      }
    };

    let validate_receiveAddress = (rule, value, callback) => {
      console.log(this.formData,"=========2222222")
      if (
        this.formData.province != "香港特别行政区" &&
        this.formData.province != "澳门特别行政区" &&
        !this.formData.area
      ) {
        callback(new Error());
      } else {
        callback();
      }
    };
    
    return {
      toStore:'',
      fromStore:'',
      fromStoreId: '',
      toStoreId: '',
      fromLocId: '',
      toLocId: '',
      pageTitle: "",
      transferNo: "",
      searchTime: 0,
      parentUrl: "/modules/wms/manage/transfer", //列表页链接
      formData: {
        // fromBodyId: '',
        // fromStoreId: '',
        // fromLocId: '',
        // toBodyId: '',
        // toStoreId: '',
        // toLocId: '',
      },
      transferId: "",
      // storehouseList: [],
      formStoreList: [], //调出分仓
      toStoreList: [], //调入分仓
      categoryOptions: [], //分类选项
      categoryId: "",
      showAddGoodDialog: false,
      suggest: "",
      goodsSuggest: "",

      breadcrumb: [],
      showGoodsDetail: false, // 是否展示批量按钮
      goodsList: [],
      tempGoodsList: [],
      goodsAllList: [],
      selectedGoods: [], //已选择的商品
      totalNum: 0,
      goodsOptions: [],
      oneGoodSelected: {},
      oneGoodSuggest: "",
      selectedListGoods: [], //列表选择的商品
      showMenuFlag: false, //是否显示下拉框
      fromLocOptions: [], // 调出仓位分仓
      toLocOptions: [], // 调入仓位分仓
      // locOptions: [], //仓位分仓
      thirdOptions: [
        { id: "1", label: "是" },
        { id: "0", label: "否" },
      ],
      allText: "全部",
      otherText: "其他",
      selectedOptions: [], //选中的省市区
      options: regionData, //省市区数据
      storeMainList: [], //仓库主体
      rules: {
        fromBodyId: [
          {
            required: true,
            validator: validate_fromBodyId,
            message: "请依次选择调出仓库的主体,仓库,仓位",
          },
        ],
        toBodyId: [
          {
            required: true,
            validator: validate_toBodyId,
            message: "请依次选择调入仓库的主体,仓库,仓位",
          },
        ],
        receiver: [
          {
            required: true,
            message: "请填写收货人",
          },
        ],
        receiveAddress: [
          {
            required: true,
            message: "请填写详细收货地址",
          },
          {
            validator: validate_receiveAddress,
            message: "请选择收货地址",
          },
        ],
        mobile: [
          {
            required: true,
            message: "请填写手机号",
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "手机号格式错误",
            trigger: "blur",
          },
        ],
        thirdFlag: [
          {
            required: true,
            message: "请选择是否三方确认",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    //初始化参数
    if (this.$route.query.rowId) {
      if(this.$route.query.flag){
        this.showGoodsDetail = true;
        this.pageTitle = "编辑调拨";
      }else{
        this.showGoodsDetail = false;
        this.pageTitle = "查看调拨";
      }
      let rowId = this.$route.query.rowId;
      console.log(rowId, "=====");
      this.init(rowId);
    } else {
      this.showGoodsDetail = true;
      this.pageTitle = "新增调拨";
    }
    // this.init();
    this.getCategoryList();
    this.getMainList();
  },
  methods: {
    handleSelectionChange(val) {
      this.selectedListGoods = val;
    },
    //商品合计处理
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 6 || index === 7) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += "";
          } else {
            // sums[index] = 'N/A';
          }
        }
      });
      return sums;
    },
    //初始化
    async init(rowId) {
      this.transferId = rowId;
      console.log(rowId, "========");
      TransferApi.getTransferInfo({
        transferStoreId: rowId,
      }).then((res) => {
        if (res.code === 0) {
          let result = res.result;
          console.log(result.wmsTransferStore, "========");

          // wmsTransferStore
          this.fromStore=result.wmsTransferStore.fromStore
          this.toStore=result.wmsTransferStore.toStore
          this.fromStoreId=Number(result.wmsTransferStore.fromStoreId)
          console.log(this.fromStoreId,typeof(this.fromStoreId))
          this.toStoreId=Number(result.wmsTransferStore.toStoreId) 
          this.toLocId=Number(result.wmsTransferStore.toLocId)
          this.fromLocId= Number(result.wmsTransferStore.fromLocId)
          // result.wmsTransferStore.thirdFlag = Number(result.wmsTransferStore.thirdFlag);
          this.formData=result.wmsTransferStore;
          this.formData.fromBodyId = Number(result.wmsTransferStore.fromBodyId);
          this.formData.toBodyId = Number(result.wmsTransferStore.toBodyId);
          this.formData.transferResson = result.wmsTransferStore.transferResson;
          this.formData.receiver = result.wmsTransferStore.receiver;
          this.formData.receiveAddress = result.wmsTransferStore.receiveAddress;
          this.formData.transitNo = result.wmsTransferStore.transitNo;
          this.formData.thirdFlag = Number(result.wmsTransferStore.thirdFlag);
          this.formData.province = result.wmsTransferStore.province;
          this.formData.city = result.wmsTransferStore.city;
          this.formData.area = result.wmsTransferStore.area;
          this.formData.mobile = result.wmsTransferStore.mobile;

          this.goodsList=result.wmsTransferStoreRelList;

          console.log(this.formData, "formData");

          this.getFromMainOptions(this.formData.fromBodyId,"init");
          this.getToMainOptions(this.formData.toBodyId,"init");
          this.getToLocOptions(this.toStoreId,"init");
          this.getFromLocOptions(this.fromStoreId,"init");
          //处理地址等信息渲染
          this.showStorageInfo();
        }
      });

     
    },
    //获取主体列表
    async getMainList() {
      let that = this;
      let resp = await TransferApi.getMainList({});
      if (resp.code == 0 && resp.succ == 1) {
        let result = resp.result;
        result.map((item) => {
          item.label = item.bodyName;
          item.value = item.bodyId;
        });
        that.storeMainList = result;
      }
    },

    // 选择主体
    async getFromMainOptions(id,flag) {
      if(!flag){
        this.fromStoreId=''
        this.fromLocId=''
      }
      console.log(id,"====id")
      let that = this;
      if (id == "") {
        this.$notifyError("请先选择主体");
      } else {
        let resp = await TransferApi.getStoreList({
          bodyId:id,
        });
        if (resp.code == 0 && resp.succ == 1) {
          let result = resp.result;
          result.map((item) => {
            item.label = item.wsName;
            item.value = item.wsId;
          });
          that.formStoreList = result;
          console.log(that.formStoreList,"formStoreList")
          that.fromLocOptions = [];
          that.formData.fromStoreId = "";
          that.formData.fromLocId = "";
          // that.goodsList = [];
        }
      }
    },
    async getToMainOptions(id,flag) {
      if(!flag){
        this.toStoreId='';
        this.toLocId='';
      }
      let that = this;
      if (id == "") {
        this.$notifyError("请先选择主体");
      } else {
        let resp = await TransferApi.getStoreList({
          bodyId: id,
        });
        if (resp.code == 0 && resp.succ == 1) {
          let result = resp.result;
          result.map((item) => {
            item.label = item.wsName;
            item.value = item.wsId;
          });
          that.toStoreList = result;
          that.toLocOptions = [];
          that.formData.toStoreId = "";
          that.formData.toLocId = "";
          // that.goodsList = [];
        }
      }
    },

    // 选择仓位
    async getFromLocOptions(id,flag) {
      if(!flag){
        this.fromLocId=''
      }
      console.log("id222", id);
      if (id == "") {
        this.$notifyError("请先选择仓库");
      } else {
        let resp = await WmsWarehouseApi.getLocAll({
          wsId: id,
        });
        this.fromLocOptions = resp.result
          ? resp.result.map((item) => {
              let obj = {};
              obj.value = item.id;
              obj.label = item.locName;
              return obj;
            })
          : [];
        this.formData.fromLocId = "";
        // this.goodsList = [];
        // console.log("this.goodsList", this.goodsList); 
      }
    },
    async getToLocOptions(id,flag) {
      if(!flag){
        this.toLocId=''
      }
      if (id == "") {
        this.$notifyError("请先选择仓库");
      } else {
        let resp = await WmsWarehouseApi.getLocAll({
          wsId: id,
        });
        this.toLocOptions = resp.result
          ? resp.result.map((item) => {
              let obj = {};
              obj.value = item.id;
              obj.label = item.locName;
              return obj;
            })
          : [];
        this.formData.toLocId = "";
        // this.goodsList = [];
      }
    },

    //获取分仓
    async getStorehouseList() {
      let resp = await Mod_Role_Warehouse.getWarehouseList_raw();
      let data = [];
      if (resp && resp.length) {
        resp.forEach((item) => {
          let { wsId, wsCode, wsName } = item;
          data.push({ id: wsId, label: wsName });
        });
      }
      this.storehouseList = data;
    },
    //获取分类
    async getCategoryList() {
      let resp = await CommodityCategoryApi.getCategoryList({});
      let resList = resp.result;
      if (resList) {
        //获取三级分类
        let finalList = [];
        resList.map((item) => {
          let child = getThreeCategory(item);
          if (child && child.length > 0) {
            child.map((item) => finalList.push(item));
          }
        });
        finalList &&
          finalList.map((item) => {
            let obj = {};
            obj.id = item.id;
            obj.label = item.categoryName;
            this.categoryOptions.push(obj);
          });
      }
    },
    async getTransferInfo() {
      let rep = await TransferApi.getTransferInfo({
        transferStoreId: this.transferId,
      });
      if (rep.succ == 1) {
        let { transferStoreBo, transferStoreSkuShowBoList } = rep.result;
        let {
          fromBodyId,
          toBodyId,
          fromStoreId,
          toStoreId,
          transferResson,
          receiver,
          receiveAddress,
          transitNo,
          toLocId,
          fromLocId,
          thirdFlag,
          province,
          city,
          area,
          mobile,
        } = transferStoreBo;

        await this.getFromMainOptions(fromBodyId);
        await this.getToMainOptions(toBodyId);
        await this.getToLocOptions(toStoreId);
        await this.getFromLocOptions(fromStoreId);

        this.formData = {
          fromBodyId: Number(fromBodyId),
          toBodyId: Number(toBodyId),
          fromStoreId: Number(fromStoreId),
          toStoreId: Number(toStoreId),
          toLocId: Number(toLocId),
          fromLocId: Number(fromLocId),
          thirdFlag: thirdFlag,
          province,
          city,
          area,
          mobile,
          receiver,
          receiveAddress,
          transferResson,
          transitNo,
        };
        console.log("formData", this.formData);
        this.goodsList = transferStoreSkuShowBoList;
        this.tempGoodsList = transferStoreSkuShowBoList;
        //处理地址等信息渲染
        this.showStorageInfo();
      } else {
        this.$notifyError("获取商品失败：" + rep.error);
      }
    },
    //新增商品
    async addNewGoods() {
      if (!this.fromStoreId || !this.fromLocId) {
        return this.$notifyError("请先选择调出仓库及仓位");
      }
      //获取分类
      this.goodsSuggest = "";
      this.showAddGoodDialog = true;
      this.selectedGoods = [];
      //获取商品列表
      this.getAllGoods();
    },
    //获取所有商品
    async getAllGoods() {
      this.$refs.table && this.$refs.table.changePage(1);
      let param = {
        suggest: this.goodsSuggest,
        categoryId: this.categoryId,
        storeId: this.fromStoreId,
        locId: this.fromLocId,
      };
      let resp = await CommodityGoodsyApi.getSkuStocks(param);
      let resList = resp.result;
      this.goodsAllList = resList;
      console.log("=====tempGoodsList===", this.tempGoodsList);
      this.goodsAllList = resList.filter((item) => {
        let exists = false;
        if (this.tempGoodsList.length > 0) {
          this.tempGoodsList.map((good) => {
            if (good.skuId == item.skuId) {
              exists = true;
            }
          });
        }
        if (!exists) {
          return item;
        }
      });
    },
    //模糊搜索新增商品
    addSuggestGood() {
      if (Object.keys(this.oneGoodSelected).length == 0) {
        this.$notifyError("请选择要新增的商品");
      } else {
        // 做过滤
        const isRepeat = this.goodsList.findIndex(
          (v) => v.skuId === this.oneGoodSelected.skuId
        );
        if (isRepeat !== -1) {
          this.$set(
            this.goodsList[isRepeat],
            "num",
            ++this.goodsList[isRepeat].num
          );
          this.oneGoodSelected = "";
        } else {
          this.goodsList.unshift({
            ...this.oneGoodSelected,
            num: 1,
          });
          this.tempGoodsList.unshift({
            ...this.oneGoodSelected,
            num: 1,
          });
          this.oneGoodSelected = "";
        }
      }
    },
    //选择单件商品
    selectOneGood(item) {
      console.log("===selectOneGood===");
      console.log(item);
      this.oneGoodSelected = item;
      //选择并添加
      this.addSuggestGood();
    },
    //省市区联动信息处理
    handleChange(addressArr) {
      if (addressArr.length > 0) {
        this.formData.province = CodeToText[addressArr[0]];
        this.formData.city = CodeToText[addressArr[1]];
        let currArea = CodeToText[addressArr[2]]
          ? CodeToText[addressArr[2]] == this.allText
            ? this.otherText
            : CodeToText[addressArr[2]]
          : "";
        this.formData.area = currArea;
        console.log("地址信息", this.formData);
      }
    },
    //地址信息渲染
    showStorageInfo() {
      //地址信息
      if (this.formData.province != "") {
        let currArea = this.formData.area
          ? this.formData.area == this.otherText
            ? this.allText
            : this.formData.area
          : "";
        // console.log('==this.formData==', this.formData);
        let currAddressCode = currArea
          ? TextToCode[this.formData.province][this.formData.city][currArea]
              .code
          : TextToCode[this.formData.province][this.formData.city].code;
        // console.log('currAddressCode收货地址信息',currAddressCode)
        this.selectedOptions = currAddressCode;
      }
    },
    //查询列表
    // searchGoods() {
    //   if (this.suggest == "") {
    //     this.goodsList = this.tempGoodsList;
    //   } else {
    //     this.goodsList = this.tempGoodsList.filter((item) => {
    //       if (
    //         (item.skuCode && item.skuCode.indexOf(this.suggest) > -1) ||
    //         (item.skuName && item.skuName.indexOf(this.suggest) > -1)
    //       ) {
    //         return item;
    //       }
    //     });
    //   }
    // },
    //保存新增的商品
    addBillGoods() {
      if (this.goodsAllList.length > 0) {
        //已选择的数据
        if (this.selectedGoods.length > 0) {
          this.totalNum = 0;
          this.selectedGoods.map((item) => {
            // 做过滤
            const isRepeat = this.goodsList.findIndex(
              (v) => v.skuId == item.skuId
            );
            console.log("isRepeat", isRepeat);
            this.goodsList = this.goodsList.map((item) => {
              if (item.availableAmount <= 0) {
                item.num = 0;
              }
              return item;
            });

            if (isRepeat !== -1) {
              this.$set(
                this.goodsList[isRepeat],
                "num",
                ++this.goodsList[isRepeat].num
              );
            } else {
              this.goodsList.unshift({
                ...item,
                num: 1,
              });
              this.tempGoodsList.unshift(item);
            }
            this.$forceUpdate();
            // this.goodsList.push({...item, amount:1});
          });
        }
      } else {
        console.log("this.totalNum", this.totalNum);
        //  this.$notifyError("暂无商品请重新选择");
      }
    },
    //仅前台删除
    deleteGoods(index) {
      this.goodsList.splice(index, 1);
      this.tempGoodsList = this.tempGoodsList.filter(
        (item, idx) => idx != index
      );
    },
    //批量删除
    deleteBatchGoods() {
      if (this.selectedListGoods.length == 0) {
        this.$notifyError("请先选择要删除的商品");
      } else {
        this.goodsList = this.goodsList.filter((item) => {
          let delFlag = false;
          this.selectedListGoods.map((sel) => {
            if (sel.skuId == item.skuId) {
              delFlag = true;
            }
          });
          if (!delFlag) {
            return item;
          }
        });
      }
    },
    //添加弹窗商品的时候
    async handleGoodsSelected(tr) {
      console.log(tr);
    },
    // 调拨数量
    amountChange(n1, n2) {
      if (n1 > n2) {
        this.$notifyError("库存不足");
      }
    },
    //TODO校验S
    validate() {
      let pattern = /^1{1}[0-9]{10}$/;
      let {
        fromBodyId,
        toBodyId,
        fromStoreId,
        toStoreId,
        fromLocId,
        toLocId,
        receiver,
        receiveAddress,
        transitNo,
        thirdFlag,
        province,
        city,
        area,
        mobile,
      } = this.formData;
      
       if (!receiver) {
        this.$notifyError("请填写收货人");
        return false;
      } else if (!receiveAddress) {
        this.$notifyError("请填写详细地址");
        return false;
      } 
       else if (!province) {
        this.$notifyError("请选择省");
        return false;
      } else if (!city) {
        this.$notifyError("请选择市");
        return false;
      } else if (
        province != "香港特别行政区" &&
        province != "澳门特别行政区" &&
        !area
      ) {
        this.$notifyError("请选择区/县");
        return false;
      } else if (!mobile) {
        this.$notifyError("请输入手机号!");
        return false;
      } else if (mobile.split("").length != 11) {
        this.$notifyError("请输入11位手机号！");
        return false;
      } else if (!pattern.test(mobile)) {
        this.$notifyError("请输入正确的手机号！");
        return false;
      } else if (!this.goodsList.length) {
        this.$notifyError("请选择调拨商品");
        return false;
      } else {
        const isEmpty = this.goodsList.some((item) => item.num == 0);
        if (isEmpty) {
          this.$notifyError("商品调拨数量不能为0");
          return false;
        }
        return true;
      }
    },
    //执行保存
    async doSaveBill() {
       console.log(this,this.formData,"formData")
      this.$refs.form.validate((valid) => {
        if (valid) {
         
          //校验
          let flag = true;
          flag = this.validate();
          if (flag) {
            let {
              fromBodyId,
              toBodyId,
              fromStoreId,
              toStoreId,
              receiver,
              receiveAddress,
              transferResson,
              transitNo,
              toLocId,
              fromLocId,
              thirdFlag,
              province,
              city,
              area,
              mobile,
            } = this.formData;
            // console.log(fromStoreId)
            let transferStoreReq = {
              fromBodyId,
              toBodyId,
              fromStoreId,
              toStoreId,
              toLocId,
              fromLocId,
              transferResson,
              receiver,
              receiveAddress,
              transitNo,
              thirdFlag,
              province,
              city,
              area,
              mobile,
            };
            transferStoreReq.fromStoreId=this.fromStoreId;
            transferStoreReq.toStoreId=this.toStoreId;
            transferStoreReq.toLocId=this.toLocId;
            transferStoreReq.fromLocId=this.fromLocId;

            transferStoreReq.fromStore=this.fromStore;
             transferStoreReq.toStore=this.toStore;
            
            if (this.transferId) {
              transferStoreReq.id = this.transferId;
            }
            let param = {
              transferStoreReq,
              transferStoreSkuQoList: this.goodsList,
            };
            console.log(param);
            TransferApi.saveTransfer(param).then((res) => {
              if (res.succ == 1) {
                this.$notifySuccess("保存成功");
                sessionStorage.removeItem("transferInfo");
                this.$router.push({ path: this.parentUrl }).catch(() => {});
                // this.goParentPage();
              } else {
                this.$notifyError("保存失败：" + res.error);
              }
            });
          }
        }
      });
    },
    //返回父级
    goParentPage() {
      if (this.showGoodsDetail) {
        this.$vs.dialog({
          type: "confirm",
          title: `请确认`,
          text: `是否确认取消`,
          acceptText: "确认",
          cancelText: "取消",
          accept: () => {
            sessionStorage.removeItem("transferInfo");
            this.$router.push({ path: this.parentUrl }).catch(() => {});
          },
        });
      } else {
        sessionStorage.removeItem("transferInfo");
        this.$router.push({ path: this.parentUrl }).catch(() => {});
      }
    },
    //模糊搜索获取sku信息
    async searchInputSuggest(value) {
      if (!value) return;
      if (!this.fromStoreId || !this.fromLocId) {
        this.$refs["bookmarkAutoSuggest"].searchQuery = "";
        return this.$notifyError("请先选择调出仓库及仓位");
      }
      let thisSearchTime = new Date().getTime();
      this.searchTime = thisSearchTime;
      let param = {
        suggest: value,
        storeId: this.fromStoreId,
        locId: this.fromLocId,
      };
      let res = await CommodityGoodsyApi.getSkuStocks(param);
      if (thisSearchTime >= this.searchTime) {
        this.goodsOptions = res.result;
      }
      this.$forceUpdate();
    },
  },
  watch: {
    fromStoreId:{
      handler(newVal){
        let objF=this.formStoreList.filter(v=>{return this.fromStoreId==v.value})
        console.log(objF,"objF")
        if(objF.length!=0){
          this.fromStore=objF[0].label    
        }
      }
    },
     toStoreId:{
      handler(newVal){
        let objTo=this.toStoreList.filter(v=>{return this.toStoreId==v.value})
        console.log(objTo,"objTo")
        if(objTo.length!=0){
          this.toStore=objTo[0].label
        }
      }
    },
    

    goodsList: {
      handler(newVal, oldVal) {
        this.totalNum = 0;
        if (this.goodsList.length > 0) {
          this.goodsList.map((item) => {
            this.totalNum += parseInt(item.num) || 0;
            //修改tempGoodsList
            // this.tempGoodsList = this.tempGoodsList.map((temp) => {
            //   if (item.skuId == temp.skuId) {
            //     temp = item;
            //   }
            //   return temp;
            // });
          });
          this.totalNum = parseInt(this.totalNum);
        }
      },
      deep: true,
    },
    showAddGoodDialog: {
      handler(newVal) {
        if (!newVal) {
          this.categoryId = "";
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/modules/commodity-sys/commodity.scss";
.con-vs-dialog /deep/ .vs-dialog{
  max-width: 850px !important;
}
.common-wrap {
  padding: 0 24px 24px;
  &.white {
    background-color: #fff;
    padding: 0 24px 100px;
  }
}
.base-wrap {
  padding: 0 24px;
}
.vs-row {
  margin-bottom: 20px;
  .vs-col {
    align-items: center;
    .redText {
      margin-right: 8px;
    }
    &.colTitle {
      justify-content: flex-end;
      margin-right: 16px;
    }
    ::v-deep .vs-input--placeholder {
      top: 4px;
    }
    .v-select {
      width: 100%;
    }
    .vs-con-textarea {
      margin-bottom: 0;
    }
  }
}
.common-btn {
  height: 38px;
  margin-left: 0;
  font-size: 14px;
}
.addGoodsBtn {
  width: 97px;
  margin-left: -5px;
  z-index: 1000;
}
.addBatchGoodsBtn {
  width: 126px;
}
.fix-bottom {
  position: fixed;
  width: 100%;
  bottom: 0;
  padding: 11px 0;
  background-color: #f8f8f8;
  z-index: 1000;
}
.search-btn {
  height: 38px;
  line-height: 38px;
}
#edit-table /deep/ .vs-con-tbody {
  width: 1300px;
  overflow: auto;
}
.mar-left-8 {
  margin-left: 8px;
}
.search-add-wrap {
  position: relative;
  .table-inner-btn {
    position: absolute;
    right: 0;
    font-size: 14px;
    z-index: 1000;
  }
}
.input-tip {
  color: var(--vs-primary);
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5e5873;
  width: 80px;
}
.center-num {
  justify-content: center;
}
</style>
